import { Navigate, useParams } from "react-router-dom";

export default function SiteSignIns() {
  const { id } = useParams();
  return <Navigate to={id ? `/sites/${id}` : "/sites"} replace />;
}
